import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpUrlEncodingCodec } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { apiParameters } from 'src/app/configs/api.params';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class InventarService {
  public apiEndPoint = apiParameters.url;

  private selectedInventar$ = new BehaviorSubject<any>(null);
  public selectedInventar = this.selectedInventar$
    .asObservable()
    .pipe(distinctUntilChanged());

  constructor(private http: HttpClient) {}

  setInventar(inventar) {
    this.selectedInventar$.next(inventar);
  }

  getFilialInventarById(filialId: string, inventarId: string): Observable<any> {
    return this.http.get(
      `${apiParameters.url}/filials/${filialId}/inventars/${inventarId}`
    );
  }

  downloadInventarCsv(inventarId: string): Observable<any> {
    return this.http.get(
      `${apiParameters.url}/inventars/${inventarId}/products-csv`,
      { responseType: 'text' as any }
    );
  }

  copyInventar(inventarId: string, filialId: string): Observable<any> {
    return this.http.get(
      `${apiParameters.url}/filials/${filialId}/inventars/${inventarId}/copy`
    );
  }

  createInventar(filialId: string, body): Observable<any> {
    return this.http.post(
      `${apiParameters.url}/filials/${filialId}/inventars`,
      body
    );
  }

  editInventar(filialId: string, inventarId: string, body): Observable<any> {
    return this.http.patch(
      `${apiParameters.url}/filials/${filialId}/inventars/${inventarId}`,
      body
    );
  }

  deleteInventar(filialId: string, inventarId: string): Observable<any> {
    return this.http.delete(
      `${apiParameters.url}/filials/${filialId}/inventars/${inventarId}`
    );
  }

  getDeletedInventarsByFilial(filialId: string): Observable<any> {
    return this.http.get(
      `${apiParameters.url}/filials/${filialId}/deleted-inventars`
    );
  }

  getAllFilialInventars(filialId: string): Observable<any> {
    return this.http.get(`${apiParameters.url}/filials/${filialId}/inventars`);
  }

  getAllFilialInventarsSearch(filialId: string, vinSearch: string, referenceSearch: string): Observable<any> {
    return this.http.get(`${apiParameters.url}/filials/${filialId}/inventars?vin=${encodeURI(vinSearch)}&reference=${encodeURI(referenceSearch)}`);
  }

  assignWorkersToFilialInventar(
    filialId: string,
    inventarId: string,
    workerIds: string[]
  ): Observable<any> {
    let body = {
      workerIds,
    };
    return this.http.patch(
      `${apiParameters.url}/filials/${filialId}/inventars/${inventarId}/add-workers`,
      body
    );
  }

  getFilialInventarWorkers(
    filialId: string,
    inventarId: string
  ): Observable<any> {
    return this.http.get(
      `${apiParameters.url}/filials/${filialId}/inventars/${inventarId}/workers`
    );
  }

  removeWorkerFromFilialInventar(
    filialId: string,
    inventarId: string,
    workerId
  ): Observable<any> {
    let body = {
      workerIds: workerId,
    };
    return this.http.patch(
      `${apiParameters.url}/filials/${filialId}/inventars/${inventarId}/remove-workers`,
      body
    );
  }

  getIventarActivityLog(filialId: string, inventarId: string): Observable<any> {
    return this.http.get(
      `${apiParameters.url}/filials/${filialId}/inventars/${inventarId}/activity-log`
    );
  }

  getAllInventars( page: number,
    limit: number, companyId?: string, name?:string): Observable<any> {
    let searchParams = new HttpParams();

    if (companyId && companyId !== '') {
      searchParams = searchParams.append('companyId', companyId);
    }
    if (name && name !== '') {
      searchParams = searchParams.append('name', name);
    }

    const httpOptions = {
      params: searchParams,
      headers: new HttpHeaders({
        page: page.toString(),
        limit: limit.toString(),
      }),
    };

    return this.http.get(
      `${apiParameters.url}/inventars`, httpOptions
    );
  }
}
